import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SecurityContext,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FileHandle} from 'src/app/common/directives/dnd/dragDrop.directive';
import {MultimediamanagementService} from '../services/multimediamanagement.service';
import {MultiMediaBasicInfo} from 'src/app/common/models/MultiMediaBasicInfo';
import {ResponseModel} from 'src/app/common/models/ResponseModel';
import {environment} from 'src/environments/environment';
import {MultimediaPopupResponse} from 'src/app/common/models/PopupResponse';
import {DateTooltipPlace, MultimediaTypes, PopupResponseEvents, TooltipPosition} from 'src/app/common/enums/enums';
import {LoadingService} from '../../../../services/UI/loading.service';
import {GuidGenerator} from 'src/app/common/helpers/guid-generator';
import {CropFrameMode} from '../../../../common/enums/enums';
import {CropInfo} from 'src/app/common/models/CropInfo';
import {DomSanitizer} from '@angular/platform-browser';
import {CustomError} from 'src/app/common/helpers/custom-error';
import {MultimediahandlerService} from '../services/multimediahandler.service';
import {ParentCommunicatorService} from 'src/app/services/parent-communicator.service';
import {ParentMessageType} from 'src/app/common/models/ParentMessage';

class InputsModel {
  constructor(
    public caption: string = '',
    public tag: string = '',
    public date: string = '',
    public place: string = '',
    public description: string = '',
    public mediaType: number = 1) {
  }
}

@Component({
    selector: 'app-multimediaupload',
    templateUrl: './multimediaupload.component.html',
    styleUrls: ['./multimediaupload.component.scss'],
    standalone: false
})
export class MultimediauploadComponent implements OnInit, OnChanges {
  public message: string;
  isFileAdded: boolean = false;
  showCropPannel: boolean = true;
  imageUrl: any;
  fileObject: any;
  dropZoneInfo: any;
  @ViewChild('f') form: any;

  model: MultiMediaBasicInfo;

  @Input() title: string;
  @Input() titleBelongs: string;
  @Input() cropFrameMode: CropFrameMode;
  @Input() editMultimediaBasicInfo: MultiMediaBasicInfo;
  @Input() acceptedMultimediaTypes: any;
  @Input() isFullScreenPopUp: boolean;
  @Input() popupWidth: string;
  @Output() saveButtonChange = new EventEmitter<boolean>();
  @Output() clearEditingMultimedia = new EventEmitter();
  @Output() changeTab = new EventEmitter();

  acceptFileImageType = environment.ACCEPTED_IMAGE_FILE_TYPE;
  acceptAudioFileType = environment.ACCEPTED_AUDIO_FILE_TYPE;
  acceptVideoFileType = environment.ACCEPTED_VIDEO_FILE_TYPE;
  acceptDocumentFileType = environment.ACCEPTED_DOCUMENTS_FILE_TYPE;

  acceptImageFileSize = environment.ACCEPTED_IMAGE_FILE_SIZE;
  acceptVideoFileSize = environment.ACCEPTED_VIDEO_FILE_SIZE;
  isAcceptedFiles: boolean = true;
  fileErrorMessage: string;

  isInvalidDate: boolean = false;
  nonImagePreview: string;
  editMediaInfoType: number;
  tooltipPosition: TooltipPosition;
  dateTooltipPlace: DateTooltipPlace;
  panelWidth: number;
  marignWidth: number = 50;
  popupStyle: string;

  constructor(
    private sanitizer: DomSanitizer,
    private loadingService: LoadingService,
    private multimediaManagementService: MultimediamanagementService,
    private multimediahandlerservice: MultimediahandlerService,
    private parentCommunicatorService: ParentCommunicatorService) {
  }

  ngOnInit(): void {
    this.panelWidth = Number(this.popupWidth.replace('%', ''));
    this.setPopupStyle(this.panelWidth);
    this.model = this.editMultimediaBasicInfo ?? new MultiMediaBasicInfo();
    this.model.mediaType = 1;
    // this.tooltipPosition = TooltipPosition.Bottom;
    this.dateTooltipPlace = DateTooltipPlace.MultimediaPopup;
  }

  setPopupStyle(panelWidth: number) {
    this.popupStyle = (panelWidth > this.marignWidth) ? "main" : "short";
    this.tooltipPosition = (this.popupStyle == "main") ? TooltipPosition.Bottom : TooltipPosition.Top;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        let self = this;// Self reference required
        switch (propName) {
          case 'editMultimediaBasicInfo': {
            if (self.editMultimediaBasicInfo) {
              self.model = this.editMultimediaBasicInfo;
              self.editMediaInfoType = Number(this.editMultimediaBasicInfo.mediaType);
              self.isFileAdded = false;
              if (self.model.originalMediaUrl) {
                self.dataUrl(self.model.originalMediaUrl, function (dataUrl) {
                  self.isFileAdded = true;
                  self.editPreview(dataUrl, self.editMultimediaBasicInfo.fileName);
                })
              }
            }
          }
        }
      }
    }
  }

  dataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  errorValidation(file) {
    let editMediaInfo = this.editMediaInfoType ?? null;
    let fileType = this.setMediaType(file).type;
    let fileSize = file.size;
    if (file == null || !this.acceptedMultimediaTypes.some(x => x === fileType)) {
      this.fileErrorMessage = 'val_unsupported_file_type';
      this.isFileAdded = false;
      this.isAcceptedFiles = false;
      return false;
    }
    else if (editMediaInfo != null && !isNaN(editMediaInfo) && !(editMediaInfo === fileType)) {
      this.fileErrorMessage = 'val_file_replace_warning';
      this.isFileAdded = false;
      this.isAcceptedFiles = false;
      return false;
    }
    else if (this.acceptedMultimediaTypes.some(x => x === fileType) && fileType != MultimediaTypes.VIDEO && parseFloat(fileSize) >= this.acceptImageFileSize) {
      this.fileErrorMessage = 'val_file_size_5mb';
      this.isFileAdded = false;
      this.isAcceptedFiles = false;
      return false;
    }
    else if (fileType == MultimediaTypes.VIDEO && parseFloat(fileSize) >= this.acceptVideoFileSize) {
      this.fileErrorMessage = 'val_file_size_15mb';
      this.isFileAdded = false;
      this.isAcceptedFiles = false;
      return false;
    }
    else {
      return true;
    }
  }

  setMediaType(file) {
    var FileType = this.multimediahandlerservice.getMediaType(file);
    return FileType;
  }

  preview(data) {
    if (this.errorValidation(data) && this.setMediaType(data).type === MultimediaTypes.PHOTO) {
      this.fileObject = data;
      var reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload = (_event) => {
        this.imageUrl = reader.result;
      }
      this.isFileAdded = true;
      this.isAcceptedFiles = true;
      this.showCropPannel = true;
    }
    else if (this.errorValidation(data)) {
      this.fileObject = data;
      this.isFileAdded = true;
      this.isAcceptedFiles = true;
      this.showCropPannel = false;
      this.nonImagePreview = this.setMediaType(data).url;
    }
    this.saveButtonChange.emit(this.isFileAdded);

  }

  editPreview(dataURI, fileName) {
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    //New Code
    //return new Blob([ab], { type: mimeString });
    let editImageFile = new File([new Blob([ab], { type: mimeString })], fileName, { type: mimeString });

    let fileHandle = new FileHandle();
    fileHandle.file = editImageFile;
    fileHandle.url = dataURI;
    fileHandle.size = editImageFile.size;
    fileHandle.type = editImageFile.type;

    if (this.errorValidation(fileHandle) && this.setMediaType(fileHandle).type === MultimediaTypes.PHOTO) {
      this.imageUrl = this.sanitizer.sanitize(SecurityContext.URL, fileHandle.url);
      // this.imageUrl = file.url;

      this.fileObject = fileHandle.file;
      this.isAcceptedFiles = true;
    }

    else if (this.errorValidation(fileHandle)) {
      this.fileObject = fileHandle;
      this.isFileAdded = true;
      this.isAcceptedFiles = true;
      this.showCropPannel = false;
      this.nonImagePreview = this.setMediaType(fileHandle).url;
    }
    this.setDropZoneProperties();
    this.saveButtonChange.emit(this.isFileAdded);


  }

  setDropZoneProperties() {
    let dropZone = document.getElementById('dropZone');
    if (dropZone) {
      let width = dropZone.clientWidth;
      let height = dropZone.clientHeight;

      this.dropZoneInfo = {
        width: width,
        height: height
      } as any;
    }
  }

  filesDropped(file: FileHandle): void {
    if (this.errorValidation(file) && this.setMediaType(file).type == MultimediaTypes.PHOTO) {
      this.imageUrl = this.sanitizer.sanitize(SecurityContext.URL, file.url);
      this.fileObject = file.file;
      this.isFileAdded = true;
      this.isAcceptedFiles = true;
      this.showCropPannel = true;
    }
    else if (this.errorValidation(file)) {
      this.isFileAdded = true;
      this.fileObject = file.file;
      this.isAcceptedFiles = true;
      this.showCropPannel = false;
      this.nonImagePreview = this.setMediaType(file).url;
    }
    this.setDropZoneProperties();
    this.saveButtonChange.emit(this.isFileAdded);
  }

  removeBtnClick() {
    this.fileObject = null;
    this.imageUrl = '';
    this.isFileAdded = false;
  }

  chooseBtnClick() {
    document.getElementById('chooseFile').click();
    this.setDropZoneProperties();
  }

  saveMultiMediaData() {
    // Save button implementation for media upload
    this.upload();
  }

  fileCropInfoUpdate(cropInfo: CropInfo) {
    this.model.cropInfo = cropInfo;
    // console.log('crop info Height: ' + cropInfo.Height);
  }

  upload() {
    if (this.form.valid && this.isFileAdded) {
      let formData = new FormData();
      formData.append('files', this.fileObject, this.fileObject.name);
      formData.append('fileInfo', JSON.stringify(this.model));

      console.log("Inside upload = " + this.model);

      let processId = GuidGenerator.generate();
      this.loadingService.show(processId);
      if (this.model.id && this.model.id > 0) {
        this.multimediaManagementService.editIndividualMultiMediaData(formData, this.model.id)
          .subscribe((response: ResponseModel<MultiMediaBasicInfo>) => {
            this.form.reset();
            this.isFileAdded = false;
            this.clearEditingMultimedia.emit(response.data);
            this.selected(response.data, true);
            this.loadingService.hide(processId);
          }, (err) => {
            this.loadingService.hide(processId);
            throw new CustomError("MultimediauploadComponent => Upload() : " + err, 911, false);
          })
      }
      else {
        this.multimediaManagementService.uploadIndividualMultiMediaData(formData)
          .subscribe((response: ResponseModel<MultiMediaBasicInfo>) => {
            this.form.reset();
            this.isFileAdded = false;
            this.selected(response.data, false);
            this.loadingService.hide(processId);
          }, (err) => {
            this.loadingService.hide(processId);
            throw new CustomError("MultimediauploadComponent => Upload() : " + err, 911, false);
          });
      }
    }
  }

  selected(uploadedImageData: any, reload: boolean) {
    let popupResponse = new MultimediaPopupResponse();
    popupResponse.Status = PopupResponseEvents.Selected;
    popupResponse.reload = reload;
    popupResponse.Data.push(uploadedImageData);
    this.multimediaManagementService.setSelection(popupResponse);
    if (!this.isFullScreenPopUp) {
      this.multimediaManagementService.changeVisibility(false, null);
    } else {
      this.changeTab.emit();
    }
  }

  dateValueSelected(formattedDate) {
    this.model.date = formattedDate;
    if (!formattedDate.IsValidDate) {
      this.isInvalidDate = true;
    }
    else {
      this.isInvalidDate = false;
    }

    console.log(" isInvalidDate in dateValueSelected = " + this.isInvalidDate);
  }

  cancel() {
    this.model = null;
    this.editMediaInfoType = null;
    this.clearEditingMultimedia.emit();
  }

  showNotImplemented() {
    this.parentCommunicatorService.send(
      ParentMessageType.ShowInformation,
      "not_implemented"
    );
  }
}
